import { Component, ElementRef, Input, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Subject, first, takeUntil } from 'rxjs';
import { FicheAmiService } from 'src/app/core/services/fiche.ami.service';
import { UserService } from '../../../core/user/user.service';
import { ToastService } from '../toast/toast.service';

@Component({
  selector: 'app-modal-contact',
  templateUrl: './modal-contact.component.html',
  styleUrls: ['./modal-contact.component.scss'],
})
export class ModalContactComponent implements OnInit, OnDestroy {
  private destroy$ = new Subject<void>();
  formContact: any = {
    name: '',
    lastname: '',
    phone: '',
    email: '',
    message: '',
    type: 'contact',
    rgpdoffre: false,
    rgpdpartenaire: 0,
    rgpdemail: 0,
    depnum: null,
    iduser: null,
    recaptcha: '',
  };
  email: any = {
    empty: 'Champ obligatoire',
    invalid: 'E-mail invalide',
  };
  invalidOrEmpty: any;
  global: any;
  dep: any;
  concession: any;
  iduser: any;
  @Input() id?: number;
  @Input() full?: any;
  @Input() txtButton?: any;
  @Input() ami?: any;
  @Input() bien?: any;
  @Input() placeholder: string = 'Précisez votre demande en quelques mots...';
  public user: any;
  launchedRequest = false;
  validRecaptcha = true;
  // Utilisez cette clé secrète pour la communication entre votre site et le service reCAPTCHA.
  keysecretRecaptchaService = '6LeyDagaAAAAAGWGgua6D1S5Xgl3e3aKh0JfNw4W';
  // Utilisez cette clé de site dans le code HTML de votre site destiné aux utilisateurs.
  siteKey = '6LeyDagaAAAAAHTNJoHHoiFJLSgM0IcjVTcPsETM';
  modalRef: any;
  userConnected?: any = {};

  constructor(
    private userService: UserService,
    public activatedRoute: ActivatedRoute,
    private modalService: NgbModal,
    private amiService: FicheAmiService,
    private toastService: ToastService
  ) {
    this.activatedRoute.params.pipe(takeUntil(this.destroy$)).subscribe((params) => {
      this.concession = params['concession'];
      this.dep = params['dep'];
      this.iduser = params['idcontact'];
    });
  }

  ngOnInit() {
    this.invalidOrEmpty = this.email.empty;
    this.userConnected = this.userService.getUser();
    this.formContact.name = this.userConnected ? this.userConnected.nom : '';
    this.formContact.lastname = this.userConnected
      ? this.userConnected.prenom
      : '';
    this.formContact.email = this.userConnected
      ? this.userConnected.usermail
      : '';
    this.formContact.phone = this.userConnected ? this.userConnected.phone : '';
  }

  openVerticallyCentered(content: any) {
    this.launchedRequest = false;
    if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
    }
    this.modalRef = this.modalService.open(content, {
      centered: true,
      size: 'xl',
    });
  }

  onSendContact(param: any, contactForm: any, id?: number) {
    if (!this.launchedRequest && this.validRecaptcha) {
      this.launchedRequest = true;
      if (this.dep !== null) {
        param.depnum = this.dep;
      }
      if (this.iduser !== null) {
        param.iduser = this.iduser;
      }
      param.idami = this.ami?.id || this.bien?.local_market_expert?.id;
      param.id = id ? id : (this.bien?.id ? this.bien.id : null);
      if (this.bien) {
        param.idbien = this.bien.id;
        if (this.bien.numero_mandat || this.bien.numeroMandat) {
          param.numeroMandat = this.bien.numero_mandat || this.bien.numeroMandat;
        }
      }
      this.amiService
        .contactAmi(param)
        .pipe(first())
        .subscribe(
          (response: any) => {
            this.modalService.dismissAll();
            this.showSuccess(
              'Votre message a bien été envoyé, nous vous remercions pour votre visite.'
            );
          },
          (err: any) => {
            this.launchedRequest = false;
            this.showDanger(
              "Votre message n'est pas envoyé, veuillez réessayer plus tard."
            );
          }
        );
    }
  }

  showSuccess(message: any) {
    this.toastService.show(message, {
      classname: 'bg-success text-light',
      delay: 10000,
    });
  }

  showDanger(dangerTpl: any) {
    this.toastService.show(dangerTpl, {
      classname: 'bg-danger text-light',
      delay: 10000,
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  checkValidEmail(value: any) {
    // let regexMail = /^[-a-z0-9~!$%^&*_=+}{\'?]{1,}(\.[-a-z0-9~!$%^&*_=+}{\'?]+)*@([a-z0-9_][-a-z0-9_]*(\.[-a-z0-9_]+)*\.([a-z]{2,})|([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}))(:[0-9]{1,5})?$/;
    if (!value) {
      this.invalidOrEmpty = this.email.empty;
    } else {
      if (this.validateEmail(value)) {
        this.invalidOrEmpty = '';
      } else {
        setTimeout(() => (this.invalidOrEmpty = this.email.invalid), 100);
      }
    }
  }

  validateEmail(email: any) {
    const re = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/; // NOSONAR
    return re.test(email);
  }

  handleSuccess(e?: any) {
    this.validRecaptcha = true;
  }

  handleExpire() {
    // console.log('expire')
    this.validRecaptcha = false;
  }
}

function ViewChild(
  arg0: string
): (target: ModalContactComponent, propertyKey: 'content') => void {
  throw new Error('Function not implemented.');
}
